import { defineComponent as m, openBlock as t, createElementBlock as o, mergeProps as d, unref as H, renderSlot as i, createElementVNode as e, createCommentVNode as p } from "vue";
import { useScalarIcon as u } from "../hooks/useScalarIcon.js";
const g = { key: 0 }, M = { key: 1 }, f = { key: 2 }, A = { key: 3 }, h = { key: 4 }, k = { key: 5 }, w = {
  name: "ScalarIconTextAlignCenter"
}, V = /* @__PURE__ */ m({
  ...w,
  props: {
    label: {},
    weight: {}
  },
  setup(l) {
    const r = l, { bind: s, weight: n } = u(r);
    return (Z, a) => (t(), o("svg", d({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, H(s)), [
      i(Z.$slots, "default"),
      H(n) === "bold" ? (t(), o("g", g, a[0] || (a[0] = [
        e("path", { d: "M28,64A12,12,0,0,1,40,52H216a12,12,0,0,1,0,24H40A12,12,0,0,1,28,64ZM64,92a12,12,0,0,0,0,24H192a12,12,0,0,0,0-24Zm152,40H40a12,12,0,0,0,0,24H216a12,12,0,0,0,0-24Zm-24,40H64a12,12,0,0,0,0,24H192a12,12,0,0,0,0-24Z" }, null, -1)
      ]))) : H(n) === "duotone" ? (t(), o("g", M, a[1] || (a[1] = [
        e("path", {
          d: "M216,64V168a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V64Z",
          opacity: "0.2"
        }, null, -1),
        e("path", { d: "M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64ZM64,96a8,8,0,0,0,0,16H192a8,8,0,0,0,0-16Zm152,40H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm-24,40H64a8,8,0,0,0,0,16H192a8,8,0,0,0,0-16Z" }, null, -1)
      ]))) : H(n) === "fill" ? (t(), o("g", f, a[2] || (a[2] = [
        e("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM176,184H80a8,8,0,0,1,0-16h96a8,8,0,0,1,0,16Zm16-32H64a8,8,0,0,1,0-16H192a8,8,0,0,1,0,16ZM72,112a8,8,0,0,1,8-8h96a8,8,0,0,1,0,16H80A8,8,0,0,1,72,112ZM192,88H64a8,8,0,0,1,0-16H192a8,8,0,0,1,0,16Z" }, null, -1)
      ]))) : H(n) === "light" ? (t(), o("g", A, a[3] || (a[3] = [
        e("path", { d: "M34,64a6,6,0,0,1,6-6H216a6,6,0,0,1,0,12H40A6,6,0,0,1,34,64ZM64,98a6,6,0,0,0,0,12H192a6,6,0,0,0,0-12Zm152,40H40a6,6,0,0,0,0,12H216a6,6,0,0,0,0-12Zm-24,40H64a6,6,0,0,0,0,12H192a6,6,0,0,0,0-12Z" }, null, -1)
      ]))) : H(n) === "regular" ? (t(), o("g", h, a[4] || (a[4] = [
        e("path", { d: "M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64ZM64,96a8,8,0,0,0,0,16H192a8,8,0,0,0,0-16Zm152,40H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm-24,40H64a8,8,0,0,0,0,16H192a8,8,0,0,0,0-16Z" }, null, -1)
      ]))) : H(n) === "thin" ? (t(), o("g", k, a[5] || (a[5] = [
        e("path", { d: "M36,64a4,4,0,0,1,4-4H216a4,4,0,0,1,0,8H40A4,4,0,0,1,36,64Zm28,36a4,4,0,0,0,0,8H192a4,4,0,0,0,0-8Zm152,40H40a4,4,0,0,0,0,8H216a4,4,0,0,0,0-8Zm-24,40H64a4,4,0,0,0,0,8H192a4,4,0,0,0,0-8Z" }, null, -1)
      ]))) : p("", !0)
    ], 16));
  }
});
export {
  V as default
};
